export default __webpack_public_path__ + "static/media/Scan-_-Go.34bfe9f4.png";